import React from 'react';
const FileViewerContext = React.createContext(null);
FileViewerContext.displayName = 'FileViewerContext';
/**
 * This provides a context that gives access to most of the useful SDK internals.
 * For use in child components, especially those rendered outside of the FVSDK which will want to use internal data.
 */
export const useFileViewerContext = () => {
    return React.useContext(FileViewerContext);
};
export const FileViewerContextProvider = FileViewerContext.Provider;
//# sourceMappingURL=file_viewer.preenvesnextjs.map
